import * as types from '../mutation-types'

const state = {
    startCheck: {
        id: "",
        needReview: false,
        recoResult: {},
        remark: ""
    },
    verifyPage: null,
    reCheckSuccess: 0
}

const getters = {
    startCheck: state => state.startCheck,
    verifyPage: state => state.verifyPage,
    reCheckSuccess: state => state.reCheckSuccess,
}

const mutations = {
    SETSTARTCHECK: (state, value) => {
        state.startCheck = value
    },
    SETVERIFYPAGE: (state, value) => {
        state.verifyPage = value
    },
    SETRECHECK: (state, value) => {
        state.reCheckSuccess++
    },
}

const actions = {
    setStartCheck({ commit }, value) {
        commit('SETSTARTCHECK', value);
    },
    setVerifyPage({ commit }, value) {
        commit('SETVERIFYPAGE', value);
    },
    setRecheck({ commit }, value) {
        commit('SETRECHECK', value);
    },
}



export default {
    state,
    getters,
    actions,
    mutations
}
